// action
export const getBundling = (state, val) => {
  state.bundlings = val
}

export const listBundling = (state, temp) => {
  state.lists = temp
}

export const bundlingForm = (state, val) => {
  state.bundling = val
}
